import css from "styled-jsx/css";
import { TABLET_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export const componentStyles = css.global`
  .cluster-selection-wrapper {
    max-width: 1050px;

    .form-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .manage-title {
        font-size: 1.913rem;
        text-align: center;

        strong {
          font-weight: bold;
        }
      }

      .manage-subtitle {
        font-size: 0.875rem;
        text-align: center;
        line-height: 26px;
        padding-top: 8px;
      }

      .cluster-selection-options-wrapper {
        padding-top: 32px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        min-height: 360px;
      }

      .selected-cluster-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 360px;
      }

      .cluster-solutions-wrapper {
        padding-top: 32px;
      }

      .button-wrapper {
        padding-top: 42px;
      }

      .button-wrapper-signup {
        padding-top: 32px;
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    .cluster-selection-wrapper {
      .form-wrapper {
        .manage-title {
          font-size: 1.375rem;
        }

        .manage-subtitle {
          font-size: 1rem;
        }

        .cluster-selection-options-wrapper {
        }

        .selected-cluster-wrapper {
          min-height: auto;
          padding-top: 40px;
        }

        .button-wrapper {
          padding-top: 8px;
        }

        .button-wrapper-signup {
          padding-top: 40px;
        }
      }
    }
  }
`;
